import React, { useState, useEffect } from 'react';
import Sidebar from "../common/Sidebar";
import { Link } from 'react-router-dom';
import { AdminGetAllOrder } from '../../Api/Admin/adminOrder';

const OrdersListPage = () => {
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        const fetchOrders = async () => {
            const token = localStorage.getItem('token');
            const orders = await AdminGetAllOrder(token);
            console.log(orders);
            setOrders(orders.data);
        };
        fetchOrders();
    }, []);


    return (
        <div className="flex min-h-screen">
            <Sidebar />
            <div className="flex-1 p-6 bg-gray-50" style={{ marginLeft: '16rem' }}>
                <h1 className="text-2xl font-bold mb-4">Orders</h1>

                <div className="bg-white shadow-lg rounded-md overflow-hidden">
                    {orders.length === 0 ? (
                        <div className="p-4 text-center text-gray-500">
                            No orders found
                        </div>
                    ) : (
                        <table className="min-w-full text-left border-collapse">
                            <thead className="bg-gray-200">
                                <tr>
                                    <th className="p-4">Order ID</th>
                                    <th className="p-4">Customer</th>
                                    <th className="p-4">Total</th>
                                    <th className="p-4">Status</th>
                                    <th className="p-4">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((order) => (
                                    <tr key={order.id} className="hover:bg-gray-100">
                                        <td className="p-4">{order._id}</td>
                                        <td className="p-4">{order.customerName}</td>
                                        <td className="p-4">{order.totalAmount}</td>
                                        <td className="p-4">{order.status}</td>
                                        <td className="p-4">
                                            <Link
                                                to={`/admin/orders/${order._id}`}
                                                className="text-blue-500 hover:underline"
                                            >
                                                View Details
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrdersListPage;
